
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Package } from "lucide-react";
import AddMembershipDialog from "./AddMembershipDialog";
import MembershipCard from "./MembershipCard";
import { MembershipWithServices } from "@/hooks/useMemberships";

interface Service {
  id: string;
  name: string;
  service_type: string;
}

interface MembershipsManagementProps {
  providerId: string;
  memberships: MembershipWithServices[];
  membershipsLoading: boolean;
  services: Service[];
  onMembershipUpdate: () => void;
  onMembershipDelete: (membershipId: string) => void;
}

const MembershipsManagement = ({ 
  providerId, 
  memberships, 
  membershipsLoading, 
  services, 
  onMembershipUpdate, 
  onMembershipDelete 
}: MembershipsManagementProps) => {
  return (
    <Card>
      <CardHeader>
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0">
          <CardTitle className="flex items-center space-x-2">
            <Package className="h-5 w-5" />
            <span>Memberships</span>
          </CardTitle>
          <AddMembershipDialog 
            providerId={providerId} 
            services={services || []}
            onMembershipAdded={onMembershipUpdate} 
          />
        </div>
      </CardHeader>
      
      <CardContent>
        {membershipsLoading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="h-64 bg-gray-200 rounded animate-pulse"></div>
            ))}
          </div>
        ) : memberships && memberships.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {memberships.map((membership) => (
              <MembershipCard 
                key={membership.id} 
                membership={membership}
                services={services || []}
                onEdit={() => {}}
                onDelete={onMembershipDelete}
              />
            ))}
          </div>
        ) : (
          <div className="text-center py-8 text-gray-500">
            <Package className="h-12 w-12 mx-auto mb-4 text-gray-300" />
            <p>No memberships created yet</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default MembershipsManagement;
